/**
 * ScaleModal - Modal pour afficher la balance
 * Wrapper autour de ScaleWidget pour une utilisation à la demande
 * Remplace le widget fixe/draggable problématique sur iPad
 */

import { Scale, X } from 'lucide-react';
import ScaleWidget from './ScaleWidget';

interface ScaleModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function ScaleModal({ isOpen, onClose }: ScaleModalProps) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
      onClick={(e) => {
        // Fermer si clic sur l'overlay (pas sur le contenu)
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden">
        {/* Header avec bouton fermer */}
        <div className="bg-gradient-to-r from-blue-500 to-blue-600 px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Scale className="h-8 w-8 text-white" />
            <h2 className="text-xl font-bold text-white">Balance</h2>
          </div>
          <button
            onClick={onClose}
            className="text-white hover:bg-white/20 rounded-full p-2 transition-colors"
            aria-label="Fermer"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        {/* Contenu = ScaleWidget existant */}
        <div className="p-4">
          <ScaleWidget />
        </div>
      </div>
    </div>
  );
}
